<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>文件拆分管理</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      文件拆分管理
      <div class="title-btn">
        <el-button type="warning" plain @click="onExport"
          v-if="$store.state.funcModuleArray.includes(1901010402)">导出</el-button>
        <el-button type="warning" plain @click="newRule"
          v-if="$store.state.funcModuleArray.includes(1901010401)">新建拆分规则</el-button>
      </div>
    </h1>
    <div class="view-content">
      <el-card class="box-card" style="margin-bottom: 20px;">
        <el-row>
          <el-col :span="6">
            <el-input v-model="search_text" class="search-text" size="small" style="width: 350px"
              placeholder="请输入映射子公司编码/映射子公司名称">
              <el-button slot="append" @click="onSearch">查找</el-button>
            </el-input>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card">
        <div class="card-content">
          <div class="table-tool">共{{ totalCount }}条</div>
          <el-table v-loading="loading" :data="tableData" style="width: 100%">
            <el-table-column prop="client_code" label="经销商编码">
            </el-table-column>
            <el-table-column prop="name" label="经销商名称"> </el-table-column>
            <el-table-column prop="count" label="拆分数"> </el-table-column>
            <el-table-column width="500" prop="yes_names" label="商业子公司映射">
              <template slot-scope="scope">
                <div class="clamp-2" :title="titleMultiLine(scope.row.yes_names)">
                  {{ scope.row.yes_names }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="parent_original_names" label="原始名称">
            </el-table-column>
            <el-table-column prop="operation" label="操作" width="200" v-if="
              $store.state.funcModuleArray.includes(1901010403) ||
              $store.state.funcModuleArray.includes(1901010404) ||
              $store.state.funcModuleArray.includes(1901010401)
            ">
              <template slot-scope="scope">
                <el-button @click.native.prevent="redact(scope.$index, scope.row)" type="text" size="small"
                  v-if="$store.state.funcModuleArray.includes(1901010401)">
                  编辑
                </el-button>
                <el-button @click.native.prevent="toAdd(scope.$index, scope.row)" type="text" size="small"
                  v-if="$store.state.funcModuleArray.includes(1901010403)">
                  添加原始名
                </el-button>
                <el-button @click.native.prevent="toDel(scope.$index, scope.row)" type="text" size="small"
                  v-if="$store.state.funcModuleArray.includes(1901010404)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
    <choose-dealer ref="chooseDealer" @saveChange="dealerSaveChange" :is-checkbox="false" :is-clear-search-text="true"
      :type="2" :table-head="[1]"></choose-dealer>

    <el-dialog title="添加原始名" :visible.sync="visible">
      <el-input rows="8" placeholder="请输入母公司原始名称，多个使用英文逗号分隔" type="textarea" v-model="parent_original_names"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ChooseDealer from "@/components/ChooseDealer";
import {
  splitFileList,
  delSplitfile,
  setParentOriginalNames
} from "@/api/index";
import { exportSplitfile } from "@/api/export";

import { titleMultiLine } from "@/util";
export default {
  name: "FileSplit",
  components: {
    ChooseDealer
  },
  data: () => ({
    currentPage: 1,
    totalCount: 0,
    tableData: [],
    visible: false,
    parent_original_names: "",
    client_id: "",
    search_text: "",
    loading: false
  }),
  created() {
    this._getList();
  },
  methods: {
    titleMultiLine,
    onSearch() {
      this._getList();
    },
    _getList() {
      this.loading = true;
      splitFileList("0", this.search_text).then(res => {
        this.loading = false;
        if (0 === res.status) {
          if (res.data.length) {
            for (const iterator of res.data) {
              iterator.yes_arr = [];
              iterator.yes_names = "";
              if (iterator.sub_list && iterator.sub_list.length) {
                for (const iterator1 of iterator.sub_list) {
                  iterator.yes_arr.push(
                    iterator1.ys_code + "-" + iterator1.ys_name
                  );
                  iterator.yes_names = iterator.yes_arr.join(",");
                }
              }
            }
          }
          this.tableData = res.data;
          this.totalCount = res.data.length;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    newRule() {
      this.$refs.chooseDealer.openDialog();
    },
    onExport() {
      let parameter = {
        search_text: this.search_text,
        type: 0
      };
      console.log(parameter, "parameterparameterparameter");
      exportSplitfile(parameter);
    },
    redact(index, row) {
      let intro = "编辑";
      let function_name = "首页>直连插件管理>文件拆分管理";
      this.$router.push({
        name: "directManageSplitSet",
        params: { id: row.client_id },
        query: {
          parent_original_names: row.parent_original_names,
          intro,
          function_name
        }
      });
    },
    dealerSaveChange(selectionVal) {
      let clientId = selectionVal[0].client_id;
      let intro = "新建拆分规则";
      let function_name = "首页>直连插件管理>文件拆分管理";
      this.$router.push({
        name: "directManageSplitSet",
        params: { id: clientId },
        query: {
          intro,
          function_name
        }
      });
    },
    toAdd(index, row) {
      console.log(index, "indexxxxxx");
      console.log(row, "rowrowrowrow");
      this.client_id = row.client_id;
      this.visible = true;
      this.parent_original_names = row.parent_original_names;
    },
    save() {
      setParentOriginalNames(
        this.client_id,
        this.parent_original_names,
        0,
        '首页/直连插件管理/文件拆分管理'
      ).then(res => {
        if (res.status == 0) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.visible = false;
          this._getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    toDel(index, row) {
      this.$confirm("是否删除该规则?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let parameters = {
            client_id: row.client_id,
            type: 0
          };
          parameters.intro = "删除";
          parameters.function_name = "首页>直连插件管理>文件拆分管理";

          delSplitfile(parameters).then(res => {
            if (0 === res.status) {
              this.$message({
                type: "success",
                message: res.msg
              });
              this._getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    }
  }
};
</script>

<style scoped>
.clamp-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
</style>
